module.exports = __webpack_public_path__ + "img/ptyy.52f321ad.png";